import {createAction} from '@reduxjs/toolkit';
import {type FeatureRef} from '@src/types/featureCollections.ts';
import {type Product} from '@src/types/products.ts';

const actionPrefix = 'QUOTA_RESERVATIONS';

export const clear = createAction(`${actionPrefix}/CLEAR`);

export const selectReleaseFeatureRefs = createAction<FeatureRef[]>(
  `${actionPrefix}/SELECT_RELEASE_FEATUREREFS`,
);

export const selectReserveFeatureRefs = createAction<FeatureRef[]>(
  `${actionPrefix}/SELECT_RESERVE_FEATUREREFS`,
);

export const selectReleaseProduct = createAction<Product | null>(
  `${actionPrefix}/SELECT_RELEASE_PRODUCT`,
);

export const selectReserveProduct = createAction<Product | null>(
  `${actionPrefix}/SELECT_RESERVE_PRODUCT`,
);

export const setMode = createAction<'reserve' | 'release'>(
  `${actionPrefix}/SET_MODE`,
);
